import { FilterBy } from '@/state/video-library/videoLibrary';
import styled from '@emotion/styled';
import { memo, useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

const Tabs = styled.div`
    display: flex;
    flex-direction: row;
    gap: 2rem;
`;

const Tab = styled.button<{ isActive: boolean }>`
    padding: 1rem 0;
    border: none;
    background: none;
    cursor: pointer;
    font-size: 1.6rem;
    color: ${props => props.theme.colors.secondary.main};
    font-weight: 600;
    position: relative;
    transition: color 0.3s ease;
    outline: none;

    &::after {
        content: '';
        position: absolute;
        bottom: -2px;
        left: 0;
        width: 100%;
        height: 2px;
        background-color: ${({ theme, isActive }) => (isActive ? theme.colors.primary.main : theme.colors.secondary[600])};
        transform: scaleX(${props => (props.isActive ? 1 : 0)});
        transition:
            transform 0.3s ease,
            background-color 0.3s ease;
    }

    &:hover::after {
        transform: scaleX(1);
    }
`;

const tabOptions = [
    { label: 'All', filter: FilterBy.ALL },
    { label: 'Videos', filter: FilterBy.VIDEOS },
    { label: 'Draft', filter: FilterBy.DRAFTS },
];

export const TabSwitcher = memo(() => {
    const [searchParams, setSearchParams] = useSearchParams();

    const activeTab = useMemo(() => searchParams.get('filter_by'), [searchParams]);

    const handleTabClick = useCallback(
        (filter: string) => {
            setSearchParams(currentSearchParams => {
                currentSearchParams.set('filter_by', filter);
                return currentSearchParams;
            });
        },
        [setSearchParams]
    );

    return (
        <Tabs>
            {tabOptions.map((tab, index) => (
                <Tab
                    key={tab.filter}
                    isActive={activeTab === tab.filter || (!activeTab && index === 0)}
                    onClick={() => handleTabClick(tab.filter)}>
                    {tab.label}
                </Tab>
            ))}
        </Tabs>
    );
});
